export default function PitchSchedule({ companyHour, slots }) {
  if (!companyHour) {
    return (
      <div className="glass p-7">
        <h2 className="font-heading text-xl text-vault-navy mb-4">Your Pitch Schedule</h2>
        <p className="text-sm text-gray-400">Book your pitch hour above to see your schedule.</p>
      </div>
    );
  }

  const hourStart = new Date(companyHour.hour_start).getTime();
  const hourEnd = new Date(companyHour.hour_end).getTime();
  const slotDuration = 15 * 60 * 1000;

  // Build 4 blocks
  const blocks = [];
  for (let t = hourStart; t + slotDuration <= hourEnd; t += slotDuration) {
    const blockStart = new Date(t);
    const blockEnd = new Date(t + slotDuration);

    // Find a slot that matches this block
    const matchingSlot = (slots || []).find(s => {
      const ss = new Date(s.slot_start).getTime();
      return Math.abs(ss - t) < 60000; // Within 1 minute tolerance
    });

    blocks.push({ blockStart, blockEnd, slot: matchingSlot });
  }

  const timeStr = (d) => d.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' });

  const statusConfig = {
    confirmed: { bg: 'bg-emerald-50 border-emerald-200', dot: 'bg-emerald-500', label: 'Zoom ready', textColor: 'text-emerald-700' },
    booked_pending_nda: { bg: 'bg-amber-50 border-amber-200', dot: 'bg-amber-500', label: 'Awaiting NDA', textColor: 'text-amber-700' },
    available: { bg: 'bg-gray-50 border-gray-200', dot: 'bg-gray-400', label: 'Slot offered — not yet booked', textColor: 'text-gray-500' },
  };

  return (
    <div className="glass p-7">
      <h2 className="font-heading text-xl text-vault-navy mb-1">Your Pitch Schedule</h2>
      <p className="text-xs text-gray-400 mb-5">
        {new Date(companyHour.hour_start).toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric' })}
        {' '}· {timeStr(new Date(companyHour.hour_start))} – {timeStr(new Date(companyHour.hour_end))}
      </p>

      <div className="space-y-2">
        {blocks.map((block, i) => {
          const { slot } = block;

          if (!slot) {
            return (
              <div key={i} className="flex items-center gap-4 px-4 py-4 rounded-xl border-2 border-dashed border-gray-200">
                <div className="text-xs font-semibold text-gray-300 w-28 shrink-0">
                  {timeStr(block.blockStart)} – {timeStr(block.blockEnd)}
                </div>
                <div className="text-sm text-gray-300">Open slot</div>
              </div>
            );
          }

          const cfg = statusConfig[slot.status] || statusConfig.available;

          return (
            <div key={i} className={`flex items-center gap-4 px-4 py-4 rounded-xl border-2 ${cfg.bg}`}>
              <div className="text-xs font-semibold text-gray-500 w-28 shrink-0">
                {timeStr(block.blockStart)} – {timeStr(block.blockEnd)}
              </div>
              <div className={`w-2 h-2 rounded-full shrink-0 ${cfg.dot}`} />
              <div className="flex-1 min-w-0">
                <div className={`text-sm font-medium ${cfg.textColor}`}>
                  {slot.inventor?.display_name || 'Inventor'}
                </div>
                <div className={`text-xs ${cfg.textColor} opacity-70`}>{cfg.label}</div>
              </div>
              {slot.status === 'confirmed' && slot.zoom_link && (
                <a
                  href={slot.zoom_link}
                  target="_blank"
                  rel="noreferrer"
                  className="px-3 py-1.5 rounded-btn text-xs font-semibold text-white shrink-0"
                  style={{ background: 'linear-gradient(135deg, #c9a84c, #F59E0B)' }}
                >
                  Join Meeting
                </a>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
